import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Animated,
  NativeModules,
  findNodeHandle,
} from 'react-native';

import Text, { getFontSize } from '../text';

const UIManager = NativeModules.UIManager;

class Label extends Component {
  constructor(props) {
    super(props);
    this.labelDim = {};
    this.offsetX = 0;
    this.placeholderHeight = 0;
    this.state = {
      progress: new Animated.Value(1),
    };

    this.handleLabelLayout = this.handleLabelLayout.bind(this);
  }

  getLabelFontScale() {
    const fontSize = getFontSize(this.props);
    return fontSize / this.props.inputFontSize;
  }

  handleLabelLayout({ nativeEvent: { layout } }) {
    const { x, y, width, height } = layout;

    if (width && !this.offsetX) {
      this.offsetX = ((width - (width * this.getLabelFontScale())) * -0.5) - x;
    }

    if (height && !this.offsetY) {
      this.offsetY = ((height - (height * this.getLabelFontScale())) * -0.5) - y;
    }

    if (height && !this.placeholderHeight) {
      this.placeholderHeight = height * this.getLabelFontScale() * 1.1;
    }

    if (width !== this.labelDim.width || height !== this.labelDim.height) {
      this.labelDim = { width, height };
    }
  }

  measure(cb) {
    return this && UIManager.measure(
      findNodeHandle(this)
    , (left, top, width, height) => {
      cb(height * this.getLabelFontScale());
    });
  }

  animationFloatLabel() {
    if (!this.props.labelEnabled) {
      return [];
    }

    return [Animated.timing(this.state.progress, {
      toValue: 0,
      duration: this.props.animationDuration,
    })];
  }

  animationSinkLabel() {
    if (!this.props.labelEnabled) {
      return [];
    }

    return [Animated.timing(this.state.progress, {
      toValue: 1,
      duration: this.props.animationDuration,
    })];
  }

  render() {
    const {
      allowFontScaling,
      inputFontSize,
      labelColor,
      labelBottomMargin,
      placeholderTextColor,
      text,
    } = this.props;

    const color = this.state.progress.interpolate({
      inputRange: [0, 1],
      outputRange: [labelColor, placeholderTextColor],
    });

    const labelScale = this.state.progress.interpolate({
      inputRange: [0, 1],
      outputRange: [this.getLabelFontScale(), 1],
    });

    const labelY = this.state.progress.interpolate({
      inputRange: [0, 1],
      outputRange: [this.offsetY, this.placeholderHeight],
    });

    const labelX = this.state.progress.interpolate({
      inputRange: [0, 1],
      outputRange: [this.offsetX, 0],
    });

    return (
      <Animated.Text
        accessible={false}
        pointerEvents="none"
        allowFontScaling={allowFontScaling}
        style={[
          this.props.style,
          {
            backgroundColor: 'transparent',
            position: 'absolute',
            top: labelY,
            left: labelX,
            color,
            fontSize: inputFontSize,
            lineHeight: inputFontSize,
            transform: [
              { scale: labelScale },
            ],
            paddingBottom: labelBottomMargin,
          },
        ]}
        onLayout={this.handleLabelLayout}
        testID="label"
      >
        {text}
      </Animated.Text>
    );
  }
}

Label.publicPropTypes = {
  labelEnabled: PropTypes.bool,
  animationDuration: PropTypes.number,
  labelBottomMargin: PropTypes.number,
  allowFontScaling: PropTypes.bool,
  placeholderTextColor: PropTypes.string,
};

Label.propTypes = {
  ...Label.publicPropTypes,
  size: Text.propTypes.size,
  labelColor: PropTypes.string,
  inputFontSize: PropTypes.number,
};

Label.defaultProps = {
  size: 'small',
  animationDuration: 200,
  labelBottomMargin: 10,
};

export default Label;
